import React from 'react';
import ToneSelector from './ToneSelector';

const InputSection = ({ message, setMessage, selectedTone, setSelectedTone, onRewrite, isProcessing }) => {
    const handleInputChange = (e) => {
        setMessage(e.target.value);
    };

    const isButtonDisabled = !message.trim() || isProcessing;

    return (
        <div className="flex-1 flex flex-col">
            <div className="flex items-center justify-between mb-2">
                <h3 className="font-semibold text-gray-700 dark:text-gray-300">Original text</h3>

            </div>
            <div className="relative flex-1 flex flex-col">
                <textarea
                    id="message-input"
                    className="flex-1 border-2 border-cyan-400 dark:border-cyan-500 rounded-lg p-4 font-mono text-sm resize-none focus:outline-none focus:border-cyan-500 dark:focus:border-cyan-400 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500"
                    placeholder="Enter original text..."
                    value={message}
                    onChange={handleInputChange}
                />
                <div className="absolute bottom-4 right-4 text-xs font-medium text-gray-400 dark:text-gray-500 bg-white dark:bg-gray-800 px-2 py-1 rounded shadow-sm border border-gray-100 dark:border-gray-700">
                    {message.length} chars
                </div>
            </div>

            {/* Tone Selector */}
            <div className="mt-4 bg-white dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-800 p-4">
                <ToneSelector
                    selectedTone={selectedTone}
                    onToneSelect={setSelectedTone}
                />
            </div>

            {/* Rewrite Button */}
            <div className="mt-4 flex justify-center">
                <button
                    onClick={onRewrite}
                    disabled={isButtonDisabled}
                    className="bg-primary-600 hover:bg-primary-700 text-white px-8 py-3 rounded-lg font-medium text-lg disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    Rewrite text
                </button>
            </div>
        </div>
    );
};

export default InputSection;
